import { createFileRoute } from '@tanstack/react-router';
import TaskpanePage from 'src/features/plugins/outlook/taskpane/page';

export const Route = createFileRoute('/plugins/outlook/taskpane/')({
  component: TaskpanePage,
});
